// extracted by mini-css-extract-plugin
module.exports = {"address":"JA-bpc"};